if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};

//#region Login Steps

rtAPI.security.call.login = async function (userName, password, samePageLogin, manageTFA) {
    return await this.APIEndPoint('login', { 'userName': userName, 'password': password, 'samePageLogin': samePageLogin, 'manageTFA': manageTFA });
}

rtAPI.security.call.autoLoginUsingTempPassword = async function (username, tempPassword, samePageLogin) {
    return await this.APIEndPoint('autoLogin', { 'username': username, 'tempPassword': tempPassword, 'samePageLogin': samePageLogin });
}

rtAPI.security.call.getLostPassword = async function (userName) {
    return await rtAPI.security.call.APIEndPoint('get-lost-password', { 'userName': userName });
}

rtAPI.security.call.getLostUsername = async function (email) {
    return await rtAPI.security.call.APIEndPoint('get-lost-username', { 'email': email });
}

rtAPI.security.call.resendAuthEmail = async function (userName) {
    return await rtAPI.security.call.APIEndPoint('resend-auth-email', { 'userName': userName });
}

rtAPI.security.call.sendSelectedMethod = async function (selectedMethod) {
    return await rtAPI.security.call.APIEndPoint('send-selected-method', { 'selectedMethod': selectedMethod });
}

rtAPI.security.call.sendAuthCode = async function (authCode) {
    return await rtAPI.security.call.APIEndPoint('send-auth-code', { 'authCode': authCode });
}

rtAPI.security.call.sendMemorableData = async function (memorableData1, memorableData2, memorableData3) {
    return await rtAPI.security.call.APIEndPoint('send-memorable-data', { 'memorableData1': memorableData1, 'memorableData2': memorableData2, 'memorableData3': memorableData3 });
}

//#endregion

//#region Logout and 2FA Management

rtAPI.security.call.logout = async function () {
    return await rtAPI.security.call.APIEndPoint('logout');
}

rtAPI.security.call.tFAManageOptionsUpdate = async function (tFAData) {
    return await rtAPI.security.call.APIEndPoint('manage-tfa', tFAData);
}

rtAPI.security.call.cancelTFA = async function () {
    return await rtAPI.security.call.APIEndPoint('cancel-tfa');
}

rtAPI.security.call.tFAManageOptionsClose = async function () {
    return await rtAPI.security.call.APIEndPoint('manage-tfa-close');
}


//#endregion

//#region Hardware Key

rtAPI.security.call.registrationStep1 = async function () {
    return await rtAPI.security.call.APIEndPoint('registration-step-1');
}

rtAPI.security.call.registrationStep2 = async function (data) {
    return await rtAPI.security.call.APIEndPoint('registration-step-2', data);
}

rtAPI.security.call.loginStep1 = async function () {
    return await rtAPI.security.call.APIEndPoint('login-step-1');
}

rtAPI.security.call.loginStep2 = async function (data) {
    return await rtAPI.security.call.APIEndPoint('login-step-2', data);
}

rtAPI.security.call.registrationRemove = async function (idDB) {
    return await rtAPI.security.call.APIEndPoint('registration-remove', { 'id': idDB });
}

rtAPI.security.call.registrationAuthorise = async function (idDB) {
    return await rtAPI.security.call.APIEndPoint('registration-authorise', { 'id': idDB });
}

rtAPI.security.call.authorisedDeviceRemove = async function (idDB) {
    return await rtAPI.security.call.APIEndPoint('authorised-device-remove', { 'id': idDB });
}

rtAPI.security.call.authorisedDeviceAuthorise = async function (idDB) {
    return await rtAPI.security.call.APIEndPoint('authorised-device-authorise', { 'id': idDB });
}



//#endregion

//#region Password

rtAPI.security.call.updatePassword = async function (oldPassword, newPassword, retypeNewPassword) {
    return await rtAPI.security.call.APIEndPoint('update-password', { 'oldPassword': oldPassword, 'newPassword': newPassword, 'retypeNewPassword': retypeNewPassword });
}

rtAPI.security.call.recoverPassword = async function (username, tempPassword, newPassword, retypeNewPassword) {
    return await rtAPI.security.call.APIEndPoint('recover-password', { 'username': username, 'tempPassword': tempPassword, 'newPassword': newPassword, 'retypeNewPassword': retypeNewPassword });
}

rtAPI.security.call.getPasswordScoreInfo = async function () {
    return await rtAPI.security.call.APIEndPoint('get-password-score-info');
}

//#endregion

//#region Actions

rtAPI.security.call.getCurrentUser = async function () {
    return await rtAPI.security.call.APIEndPoint('get-current-user');
}

rtAPI.security.call.APIEndPoint = async function (command, data) {
    return await rtAPI.call.APIEndPoint('security', command, data);
}

//#endregion

